import { render, staticRenderFns } from "./RatingOne.vue?vue&type=template&id=69d2f46c&scoped=true&"
import script from "./RatingOne.vue?vue&type=script&lang=js&"
export * from "./RatingOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d2f46c",
  null
  
)

export default component.exports